import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        getAll: () => executeCall(() => Axios.get(url, { headers: getHeaders() })),
        getPending: () => executeCall(() => Axios.get(url + '/pending', { headers: getHeaders() })),
        getUpcoming: () => executeCall(() => Axios.get(url + '/upcoming', { headers: getHeaders() })),
        reserve: (data) => executeCall(() => Axios.post(url + '/reserve', data, { headers: getHeaders() })),
        confirm: (data) => executeCall(() => Axios.post(url + '/confirm', data, { headers: getHeaders() })),
        accept: (data) => executeCall(() => Axios.post(url + '/accept', data, { headers: getHeaders() })),
        reject: (data) => executeCall(() => Axios.post(url + '/reject', data, { headers: getHeaders() })),
        cancel: (data) => executeCall(() => Axios.post(url + '/cancel', data, { headers: getHeaders() })),
        view: (id) => executeCall(() => Axios.get(url + `/${id}`, { headers: getHeaders() })),
        serverTime: (id) => executeCall(() => Axios.get(url + `/time-now`, { headers: getHeaders() })),
        getPendingNotes: () => executeCall(() => Axios.get(url + '/pending-notes', { headers: getHeaders() })),
        addSessionNote: (appointmentId, data) => executeCall(() => Axios.post(url + `/${appointmentId}/notes`, data, { headers: getHeaders() })),
        getSessionNote: (appointmentId) => executeCall(() => Axios.get(url + `/${appointmentId}/notes`, { headers: getHeaders() })),
        getClientHistory: (clientId) => executeCall(() => Axios.get(url + `/patient/${clientId}/history`, { headers: getHeaders() })),
        getIceCredentials: (roomId) => executeCall(() => Axios.get(url + `/${roomId}/ice-credentials`, { headers: getHeaders() })),
        addReview: (appointmentId, data) => executeCall(() => Axios.post(url + `/${appointmentId}/review`, data, { headers: getHeaders() })),
        getMyRating: () => executeCall(() => Axios.get(url + '/my-rating', { headers: getHeaders() })),
    };
};


export default crudder;